/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubCategory } from './SubCategory';
import {
    SubCategoryFromJSON,
    SubCategoryFromJSONTyped,
    SubCategoryToJSON,
    SubCategoryToJSONTyped,
} from './SubCategory';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';

/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    domainId?: number;
    /**
     * 
     * @type {Domain}
     * @memberof Category
     */
    Domain?: Domain;
    /**
     * 
     * @type {Array<SubCategory>}
     * @memberof Category
     */
    SubCategories?: Array<SubCategory>;
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): value is Category {
    return true;
}

export function CategoryFromJSON(json: any): Category {
    return CategoryFromJSONTyped(json, false);
}

export function CategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Category {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'Domain': json['Domain'] == null ? undefined : DomainFromJSON(json['Domain']),
        'SubCategories': json['SubCategories'] == null ? undefined : ((json['SubCategories'] as Array<any>).map(SubCategoryFromJSON)),
    };
}

  export function CategoryToJSON(json: any): Category {
      return CategoryToJSONTyped(json, false);
  }

  export function CategoryToJSONTyped(value?: Category | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'domainId': value['domainId'],
        'Domain': DomainToJSON(value['Domain']),
        'SubCategories': value['SubCategories'] == null ? undefined : ((value['SubCategories'] as Array<any>).map(SubCategoryToJSON)),
    };
}

